import { useMutation } from "react-query";
import api from "../../client";
import { CreateChecklistPayload, Checklist } from "../../types/checklist";

const postData = async (
  payload: CreateChecklistPayload,
): Promise<Checklist> => {
  const { data } = await api.post(`/checklists`, payload);

  return data;
};

export const useCreateChecklist = () => {
  return useMutation((payload: CreateChecklistPayload) => {
    return postData(payload);
  });
};
